"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.csrfTokenInterceptor = void 0;
const browser_cookies_1 = __importDefault(require("browser-cookies"));
const csrf_token_1 = require("../../utils/csrf-token");
const csrfTokenInterceptor = (authTokenName) => {
    return (url, options) => {
        const { headers } = options;
        const authToken = browser_cookies_1.default.get(authTokenName);
        const csrfToken = csrf_token_1.getCsrfToken(authToken);
        if (csrfToken) {
            return {
                url,
                options: Object.assign(Object.assign({}, options), { headers: Object.assign(Object.assign({}, headers), { 'csrf-token': csrfToken }) }),
            };
        }
        return { url, options };
    };
};
exports.csrfTokenInterceptor = csrfTokenInterceptor;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY3NyZnRva2VuLXJlcXVlc3QuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi9zcmMvbGliL3JlcXVlc3QvaW50ZXJjZXB0b3JzL2NzcmZ0b2tlbi1yZXF1ZXN0LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7OztBQUFBLHNFQUFxQztBQUdyQyx1REFBcUQ7QUFNckQsTUFBTSxvQkFBb0IsR0FBRyxDQUFDLGFBQXFCLEVBQXNCLEVBQUU7SUFDekUsT0FBTyxDQUFDLEdBQVcsRUFBRSxPQUFnQyxFQUFFLEVBQUU7UUFDdkQsTUFBTSxFQUFFLE9BQU8sRUFBRSxHQUFHLE9BQU8sQ0FBQztRQUM1QixNQUFNLFNBQVMsR0FBRyx5QkFBTSxDQUFDLEdBQUcsQ0FBQyxhQUFhLENBQUMsQ0FBQztRQUM1QyxNQUFNLFNBQVMsR0FBRyx5QkFBWSxDQUFDLFNBQVMsQ0FBQyxDQUFDO1FBRTFDLElBQUksU0FBUyxFQUFFO1lBQ2IsT0FBTztnQkFDTCxHQUFHO2dCQUNILE9BQU8sa0NBQ0YsT0FBTyxLQUNWLE9BQU8sa0NBQ0YsT0FBTyxLQUNWLFlBQVksRUFBRSxTQUFTLE1BRTFCO2FBQ0YsQ0FBQztTQUNIO1FBQ0QsT0FBTyxFQUFFLEdBQUcsRUFBRSxPQUFPLEVBQUUsQ0FBQztJQUMxQixDQUFDLENBQUE7QUFDSCxDQUFDLENBQUE7QUFFUSxvREFBb0IifQ==